import type { SupportWidgetZone } from '@lite-workspace/shared/support-widget';
import { activeClientSession, isClientPreview } from './client-session';

// Student screens (the photographer's full-screen student wizard included), the coordinator and the owner
// looking as a student never get the support chat; editors open its window above their bottom bar.
// The design editor puts its button beside the zoom control.
// A student also opens /editor and /preview outside /client: the session, not the url, hides it there.
export function supportWidgetZone(url: string): SupportWidgetZone {
  if (
    isClientPreview() ||
    activeClientSession() !== null ||
    /^\/(client|preview)\//.test(url) ||
    /^\/projects\/[^/]+\/select\//.test(url) ||
    /\/coordinator\//.test(url)
  ) {
    return 'hidden';
  }

  if (/^\/design-editor\//.test(url)) return 'design-editor';
  return /^\/editor\//.test(url) ? 'editor' : 'default';
}
